import Script from 'next/script';

export default function YandexAdScript({onError}: {onError: () => void}) {
  return (
    <Script
      id="yandex-ads"
      src="https://yandex.ru/ads/system/context.js"
      async
      onError={onError}
    />
  );
}
